import { render } from "./Personal.vue?vue&type=template&id=9fdf1c18&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"

import "./Personal.vue?vue&type=style&index=0&id=9fdf1c18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9fdf1c18"

export default script